// extracted by mini-css-extract-plugin
module.exports = {"select-only-input":"select-only-input-349V63r"};